module.exports = "pegasus_template/assets/tech/update/101.png";